import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/svg/close.svg'
import _imports_1 from '@/assets/svg/carousel/fon.svg'


const _hoisted_1 = {
  key: 0,
  class: "slide-wrapper"
}
const _hoisted_2 = { class: "slide-container" }
const _hoisted_3 = { class: "slide-text-container" }
const _hoisted_4 = { class: "slide-case-number color-green mb-2" }
const _hoisted_5 = { class: "slide-case-name mt-5" }
const _hoisted_6 = { class: "slide-case-text size-m mt-3" }
const _hoisted_7 = { class: "slide-case-text size-s my-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Проблема:", -1)
const _hoisted_9 = { class: "slide-case-text size-s" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Решение:", -1)
const _hoisted_11 = { class: "slide-case-text size-m bold mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", { class: "color-green" }, "Результат:", -1)
const _hoisted_13 = { class: "slide-img-wrapper" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "slide-img-fon",
  src: _imports_1
}, null, -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, "Кейс№" + _toDisplayString(_ctx.number), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.caseName[_ctx.number - 1]), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.caseDescription[_ctx.number - 1]), 1),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.caseProblem[_ctx.number - 1]), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_ctx.caseResolve[_ctx.number - 1]), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(_ctx.caseResult[_ctx.number - 1]), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  class: "img-slide",
                  src: require(`@/assets/svg/carousel/case-${_ctx.number}.svg`)
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("img", {
                class: "slide-close",
                src: _imports_0,
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }),
              _hoisted_15,
              _createElementVNode("img", {
                class: _normalizeClass(["slide-img", 'img-' + _ctx.number + '-1']),
                src: require(`@/assets/svg/carousel/icon-case${_ctx.number}-1.svg`)
              }, null, 10, _hoisted_16),
              _createElementVNode("img", {
                class: _normalizeClass(["slide-img", 'img-' + _ctx.number + '-2']),
                src: require(`@/assets/svg/carousel/icon-case${_ctx.number}-2.svg`)
              }, null, 10, _hoisted_17)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}